export default "__VITE_ASSET__UCXoeCIq__"